<template>
    <el-form :model="form" ref="form" :rules="rules" :inline="true" size="mini">
        <el-form-item :label="$t('orders.signedBy')" prop="deliverySignedBy">
            <el-input v-model="form.deliverySignedBy"></el-input>
        </el-form-item>
        <el-form-item :label="$t('orders.signedOn')" prop="deliveryDate">
            <el-date-picker v-model="form.deliveryDate" type="datetime" :placeholder="$t('orders.selectDateAndTime')">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">{{$t('common.save')}}</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
  name: "delivery-info",
  data() {
    return {
      form: {
        deliverySignedBy: "",
        deliveryDate: new Date()
      },
      rules: {
        deliverySignedBy: [
          {
            required: true,
                message: this.$t('common.pleaseEnterPersonName'),
            trigger: "blur"
          }
        ],
        deliveryDate: [
          {
            required: true,
                message: this.$t('common.pleaseEnterDate'),
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.$emit("update", this.form);
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// ClientApp/app/orders/components/DeliveryInfo.vue